import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { useDropzone } from 'react-dropzone';

import {
  FormField,
  HelpBlock,
  InputText,
  Label,
  Row,
} from './form';

const Prompt = styled.a`
  display: flex;
  width: 100%;

  &:active, &:focus, &:hover, &:visited {
    border: none;
    outline: none;
    text-decoration: none !important;
  }
`;

const Img = styled.img`
  max-width: 100%;
`;

const SInputText = styled(InputText)`
  &:hover {
    border-color: ${props => props.theme.secondaryColor} !important;
    cursor: pointer;
  }
`;

export default function withNameFileUpload(objectName, name, store, accept, label) {
  const kebab = _.kebabCase(name);
  const capitalize = _.capitalize(name);
  const snake = _.snakeCase(name);

  /* eslint-disable complexity */
  function PlainInput() {
    const set = store(state => state.set);
    const errors = store(state => state.errors);
    const file = store(state => state[objectName][name]);
    const contentType = store(state => state[objectName][`${name}ContentType`]) || '';
    const fileUrl = store(state => state[objectName][`${name}Url`]);
    const filename = store(state => state[objectName][`${name}Filename`]);
    const isImageFile = contentType.includes('image/');

    const {
      getRootProps, getInputProps, isDragActive, open,
    } = useDropzone({
      accept: accept || '',
      multiple: false,
      noClick: true,
      onDrop: ([f]) => set(state => {
        state[objectName][name] = f;
        state[objectName][`${name}Filename`] = f.name;
        state[objectName][`${name}ContentType`] = f.type;
        state[objectName][`${name}Url`] = URL.createObjectURL(f);
      }),
    });

    return (
      <Row>
        <Label htmlFor={kebab}>{label || name}</Label>
        <FormField {...getRootProps({ className: `dropzone${isDragActive ? ' active' : ''}` })}>
          <input {...getInputProps()} />
          <Prompt href="#" onClick={() => open()}>
            {(file || fileUrl) && isImageFile
              && <Img src={file ? URL.createObjectURL(file) : fileUrl} alt={label || capitalize} />}
            {!isImageFile && <SInputText placeholder={`Upload ${label || capitalize}`} value={filename || ''} disabled />}
          </Prompt>
          {!!errors[snake] && <HelpBlock>{errors[snake]}</HelpBlock>}
        </FormField>
      </Row>
    );
  }
  /* eslint-enable complexity */

  PlainInput.displayName = capitalize;

  return PlainInput;
}
